<template>
    <v-dialog
        v-if="visible"
        v-model="visible"
        transition="dialog-top-transition"
        persistent
        max-width="700"
    >
        <v-card class="modal-maincard">

            <v-toolbar dark flat dense>
                <v-toolbar-title>{{ $t(title) }}</v-toolbar-title>
            </v-toolbar>

            <v-card-text>
                <v-form class="wrapperFormModal" ref="form" lazy-validation>
                    <v-card flat>
                        <v-card-text>

                            <v-row no-gutters>
                                <v-col cols="12" sm="12" md="3">
                                    <label class="f-label">{{ $t("Группа") }}</label>
                                </v-col>
                                <v-col cols="12" sm="12" md="9">
                                    <v-select
                                        v-model="options.requisite.RequisiteGroup"
                                        :items="requisiteGroups"
                                        :item-text="item => $t(item.Value)"
                                        return-object
                                        hide-details
                                        outlined
                                        dense
                                        append-icon="fas fa-chevron-down"
                                        :menu-props="{ bottom: true, offsetY: true }"
                                        required
                                        :rules="requiredRule"
                                    >
                                    </v-select>
                                </v-col>
                            </v-row>

                            <v-row no-gutters>
                                <v-col cols="12" sm="12" md="3">
                                    <label class="f-label">{{ $t("Ключ_реквизита") }}</label>
                                </v-col>
                                <v-col cols="12" sm="12" md="9">
                                    <v-text-field
                                        v-model.trim="options.requisite.KeyName"
                                        hide-details
                                        outlined
                                        dense
                                        required
                                        :rules="requiredRule"
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row no-gutters>
                                <v-col cols="12" sm="12" md="3">
                                    <label class="f-label">{{ $t("Наименование_каз") }}</label>
                                </v-col>
                                <v-col cols="12" sm="12" md="9">
                                    <v-text-field
                                        v-model.trim="options.requisite.Name['kk-KZ']"
                                        hide-details
                                        outlined
                                        dense
                                        required
                                        :rules="requiredRule"
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row no-gutters>
                                <v-col cols="12" sm="12" md="3">
                                    <label class="f-label">{{ $t("Наименование_рус") }}</label>
                                </v-col>
                                <v-col cols="12" sm="12" md="9">
                                    <v-text-field
                                        v-model.trim="options.requisite.Name['ru-RU']"
                                        hide-details
                                        outlined
                                        dense
                                        required
                                        :rules="requiredRule"
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row no-gutters>
                                <v-col cols="12" sm="12" md="3">
                                    <label class="f-label">{{ $t("Тип_реквизита") }}</label>
                                </v-col>
                                <v-col cols="12" sm="12" md="9">
                                    <v-select
                                        v-model="options.requisite.RequisiteType"
                                        :items="requisiteTypes"
                                        item-value="id"
                                        :item-text="item => $t(item.value)"                                        
                                        hide-details
                                        outlined
                                        dense
                                        append-icon="fas fa-chevron-down"
                                        :menu-props="{ bottom: true, offsetY: true }"
                                        required
                                        :rules="requiredRule"
                                    >
                                    </v-select>
                                </v-col>
                            </v-row>
                            
                        </v-card-text>

                    </v-card>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                    v-if="isValidForSave"
                    color="cyan"
                    text
                    depressed
                    @click="ok"
                >
                    {{ $t("Сохранить") }}
                </v-btn>

                <v-btn 
                    color="blue-grey"
                    text
                    depressed
                    @click="cancel"
                >
                    {{ $t("Отмена") }}
                </v-btn>
            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: "CreateRequisitesGroupDlg",
    asyncComputed: {
        requisiteGroups: {
            async get() {
                return await this.$store.dispatch('references/getReference', { id: 1042 });
            },
            default: () => []
        }
    },
    computed: {
        ...mapGetters({ requiredRule: 'getRequiredRule' }),
        ...mapGetters('templates', { requisiteTypes: 'getRequisiteTypes' }),
        isValidForSave() {
            return this.options.requisite.KeyName
                && this.options.requisite.Name['kk-KZ']
                && this.options.requisite.Name['ru-RU']
                && typeof this.options.requisite.RequisiteType === 'number'
                && this.options.requisite.RequisiteGroup;
        }
    },
    data: () => ({
        title: "Реквизит",
        visible: false,
        resolve: null,
        options: {
            requisite: null
        },
    }),
    methods: {
        async open(options = {}) {
            this.reset();
            this.visible = true;
            this.options = Object.assign(this.options, options);

            if (!this.options.requisite)
                this.options.requisite = this.getNewRequisite();

            return new Promise((resolve) => { this.resolve = resolve; });
        },
        ok() {
            this.visible = false;
            this.resolve({ 
                action: 'save',
                object: this.options.requisite
            });
        },
        cancel() {
            this.visible = false;
            this.resolve({ action: 'cancel', object: null });
        },
        reset() {
            this.options.requisite = null;
        },
        getNewRequisite() {
            return {
                __type: "Requisite:#Avrora.Objects.Modules.Docflow.DocumentTemplatesNew",
                is_new_record: true,
                Name: { 'kk-KZ': null, 'ru-RU': null },
                KeyName: null,
                RequisiteType: 0,
                RequisiteGroup: null
            };
        }
    },
    updated() {
        this.$refs?.form?.validate();
    }
}
</script>